import { css } from '@emotion/core';
import { variables, tokens, shadow } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors,
  shadows = tokens.shadows;
export var footerCard = /*#__PURE__*/css("display:flex;flex-direction:column;overflow:hidden;border-radius:2px;background-color:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";vertical-align:top;padding:24px;width:320px;box-shadow:", shadow(shadows.elevation2), ";");
export var topSection = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";white-space:nowrap;");
export var profilePhotoContainer = {
  name: "c7yo1x",
  styles: "min-height:24px;"
};
export var profilePhoto = {
  name: "fa1rw7",
  styles: "max-height:36px;width:100%;object-fit:contain;object-position:left;"
};
export var name = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";line-height:24px;color:", colors.neutral.heavy.default, ";");
export var middleTextContainer = /*#__PURE__*/css("line-height:20px;font-size:", font.smallFontSize, ";color:", colors.neutral.medium.default, ";padding-bottom:31px;");
export var addressLine1 = {
  name: "ym3sz0",
  styles: "line-break:anywhere;"
};
export var bottomSectionContainer = {
  name: "ecvpot",
  styles: "display:flex;flex-direction:column;justify-content:end;width:100%;"
};
export var buttons = {
  name: "18lrmmd",
  styles: "white-space:nowrap;display:flex;gap:12px;align-items:center;justify-content:space-between;width:100%;max-width:100%;"
};
export var phoneButton = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");
export var emailButton = {
  name: "1rr4qq7",
  styles: "flex:1;"
};